import { type PlanType } from '@/types';

/**
 * 보유 플랜이 요구 플랜을 충족하는지 판단한다.
 *
 * 플랜 계층: FREE < BASIC < PRO
 * - FREE 요구: 누구나 충족
 * - BASIC 요구: BASIC 또는 PRO 보유자만 충족
 * - PRO 요구: PRO 보유자만 충족
 *
 * 사용자 플랜뿐 아니라 이용권(voucher)의 planType 비교에도 쓰이므로
 * UserPlanManager 인스턴스에 묶지 않고 순수 함수로 둔다.
 *
 * @param heldPlan - 보유 중인 플랜 (사용자 플랜 또는 이용권 플랜)
 * @param requiredPlan - 요구되는 최소 플랜
 */
export const hasEnoughPlan = (
  heldPlan: PlanType,
  requiredPlan: PlanType,
): boolean => {
  if (requiredPlan === 'FREE') return true;
  if (requiredPlan === 'BASIC') return heldPlan !== 'FREE';
  return heldPlan === 'PRO';
};
